export interface GetEventListPayload {
  entityType: JournalingEntityType;
  entityRefNo: string;
  isInitial?: boolean;
}

export interface GetEventDetailPayload {
  entityType: JournalingEntityType;
  entityRefNo: string;
  eventID: string;
}

export interface JournalingFilterParams {
  categoryName?: string;
  eventSubtype?: string;
  eventDateFrom?: string;
  eventDateTo?: string;
  originatorUserRefNo?: string;
  originatorUserLogin?: string;
  originatorContRefNo?: string;
  eventId?: string;
  originatorType: 'all' | 'contactPerson' | 'internalUser';
}

export interface JournalingPagination {
  page: number; // Default: 1
  pageSize: number; // Default: 20
  forceCheck: boolean; // Default: false
}

export enum JournalingEntityType {
  Customer = 'CUSTOMER',
  CustomerAccount = 'CUSTOMER_ACCOUNT',
  Asset = 'ASSET',
  ContactPerson = 'CONTACT_PERSON',
  InternalUser = 'INTERNAL_USER',
  Order = 'ORDER',
  CustomerRequest = 'CUSTOMER_REQUEST',
  InOutCommunication = 'IN_OUT_COMMUNICATION',
}

export const TypeMap: Record<string, JournalingEntityType> = {
  CUSTOMER: JournalingEntityType.Customer,
  CUSTOMER_ACCOUNT: JournalingEntityType.CustomerAccount,
  INTERNAL_USER: JournalingEntityType.InternalUser,
  CONTACT_PERSON: JournalingEntityType.ContactPerson,
  ASSET: JournalingEntityType.Asset,
  tariff: JournalingEntityType.Asset,
  tariffs: JournalingEntityType.Asset,
  ORDER: JournalingEntityType.Order,
  CUSTOMER_REQUEST: JournalingEntityType.CustomerRequest,
};

export enum SourcePageId {
  CoreProduct = '2.7.4',
  TariffSpace = '2.5.1',
  TariffSpaces = '2.5.5',
}
// TODO: generate/get type/subTypes from ???
export enum TicketTypeCode {
  SPLATKY = 'SPLATKY',
}
